import React from "react";

import { BreakpointStateV1, BreakpointStateV2 } from "./useBreakpoint.types";
import { BreakpointContext } from "./useBreakpoint.context";

interface Props {
  children: React.ReactNode;
  breakpoint: keyof BreakpointStateV1 | keyof BreakpointStateV2;
}

export const BreakpointTestProvider = (props: Props) => {
  return (
    <BreakpointContext.Provider
      value={{
        v1: {
          mobile: props.breakpoint === "mobile",
          tablet: props.breakpoint === "tablet",
          desktop: props.breakpoint === "desktop",
          desktopLarge: props.breakpoint === "desktopLarge",
        },
        v2: {
          mobile: props.breakpoint === "mobile",
          largeMobile: props.breakpoint === "largeMobile",
          smallTablet: props.breakpoint === "smallTablet",
          tablet: props.breakpoint === "tablet",
          smallDesktop: props.breakpoint === "smallDesktop",
          desktop: props.breakpoint === "desktop",
          largeDesktop: props.breakpoint === "largeDesktop",
        },
        isBreakpointResolved: true,
      }}
    >
      {props.children}
    </BreakpointContext.Provider>
  );
};
